/*
 * THE FURNITURE SHACK — Dining Set Builder Script
 * ─────────────────────────────────────────────────────────────
 * Extracted from dining-set-builder.liquid.
 * Config values are read from data-* attributes on the
 * .dining-set-builder element (set in the section liquid).
 * ─────────────────────────────────────────────────────────────
 */

(function () {
          var container = document.querySelector('.dining-set-builder');
          if (!container) return;
          var sectionId = container.dataset.sectionId;

          var dataEl = document.getElementById('dsb-data-' + sectionId);
          var data = {};
          try { data = dataEl ? JSON.parse(dataEl.textContent || '{}') : {}; } catch(e){ data = {}; }

          var heroDesktop = document.getElementById('dsb-hero-' + sectionId);
          var heroMobile  = document.getElementById('dsb-hero-mobile-' + sectionId);

          var tableVariantElDesktop = document.getElementById('dsb-table-variant-' + sectionId);
          var tableVariantElMobile  = document.getElementById('dsb-table-variant-mobile-' + sectionId);

          var chairButtons = Array.prototype.slice.call(container.querySelectorAll('.dsb-chair[data-chair-handle]'));

          var chairVariantWrapDesktop = document.getElementById('dsb-chair-variant-wrap-' + sectionId);
          var chairVariantElDesktop   = document.getElementById('dsb-chair-variant-' + sectionId);
          var chairVariantWrapMobile  = document.getElementById('dsb-chair-variant-wrap-mobile-' + sectionId);
          var chairVariantElMobile    = document.getElementById('dsb-chair-variant-mobile-' + sectionId);

          var chairSelectedElDesktop = document.getElementById('dsb-chair-selected-' + sectionId);
          var chairSelectedElMobile  = document.getElementById('dsb-chair-selected-mobile-' + sectionId);

          var qtyButtons = Array.prototype.slice.call(container.querySelectorAll('.dsb-qty'));

          var totalCompareEl = document.getElementById('dsb-total-compare-' + sectionId);
          var totalPriceEl   = document.getElementById('dsb-total-price-' + sectionId);

          var mobileTotalCompareEl = document.getElementById('dsb-mobile-total-compare-' + sectionId);
          var mobileTotalPriceEl   = document.getElementById('dsb-mobile-total-price-' + sectionId);

          var mobileInlineCompareEl = document.getElementById('dsb-mobile-inline-compare-' + sectionId);
          var mobileInlineTotalEl   = document.getElementById('dsb-mobile-inline-total-' + sectionId);

          var addBtnDesktop = document.getElementById('dsb-add-' + sectionId);
          var addBtnMobileSticky = document.getElementById('dsb-mobile-add-' + sectionId);
          var addBtnMobileInline = document.getElementById('dsb-mobile-inline-add-' + sectionId);

          var mobileInlineCtaWrap = document.getElementById('dsb-mobile-cta-' + sectionId);

          var msgDesktop = document.getElementById('dsb-msg-' + sectionId);
          var msgMobile  = document.getElementById('dsb-msg-mobile-' + sectionId);

          var availabilityDesktop = document.getElementById('dsb-availability-' + sectionId);
          var availabilityMobileSticky = document.getElementById('dsb-availability-mobile-' + sectionId);
          var availabilityMobileInline = document.getElementById('dsb-availability-mobile-inline-' + sectionId);

          var detailTableTitle = document.getElementById('dsb-detail-table-title-' + sectionId);
          var detailTableDesc  = document.getElementById('dsb-detail-table-desc-' + sectionId);
          var detailChairTitle = document.getElementById('dsb-detail-chair-title-' + sectionId);
          var detailChairDesc  = document.getElementById('dsb-detail-chair-desc-' + sectionId);

          var detailTableTitleM = document.getElementById('dsb-detail-table-title-mobile-' + sectionId);
          var detailTableDescM  = document.getElementById('dsb-detail-table-desc-mobile-' + sectionId);
          var detailChairTitleM = document.getElementById('dsb-detail-chair-title-mobile-' + sectionId);
          var detailChairDescM  = document.getElementById('dsb-detail-chair-desc-mobile-' + sectionId);

          var accordionDesktop = document.getElementById('dsb-accordion-' + sectionId);
          var accordionMobile  = document.getElementById('dsb-accordion-mobile-' + sectionId);
          var mobileBar = document.getElementById('dsb-mobilebar-' + sectionId);

          var currencyCode = container.dataset.currency || 'AUD';
          var redirectToCart = container.dataset.redirectToCart === 'true';

          var state = {
            tableVariantId: null,
            tablePriceCents: 0,
            tableCompareCents: 0,
            chairHandle: null,
            chairVariantId: null,
            chairPriceCents: 0,
            chairCompareCents: 0,
            qty: parseInt(container.dataset.defaultQty, 10) || 4,
            chairChosen: false,
            inlineCtaVisible: true
          };

          var isAdding = false;

          function isMobile(){
            return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
          }

          function toCents(val){
            if (val == null || val === '') return 0;
            if (typeof val === 'number') return val;
            if (typeof val === 'string') {
              if (val.indexOf('.') !== -1) return Math.round(parseFloat(val) * 100);
              var n = parseInt(val, 10);
              return isNaN(n) ? 0 : n;
            }
            return 0;
          }

          function formatMoney(cents) {
            try {
              return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currencyCode });
            } catch (e) {
              return '$' + (cents / 100).toFixed(2);
            }
          }

          function setMessage(text, ok) {
            var el = isMobile() ? msgMobile : msgDesktop;
            if (!el) return;
            el.textContent = text || '';
            el.style.opacity = text ? '1' : '0';
            el.style.color = ok ? 'inherit' : 'crimson';
          }

          function setHeroImage(url) {
            if (!url) return;
            if (heroDesktop && heroDesktop.tagName && heroDesktop.tagName.toLowerCase() === 'img') heroDesktop.src = url;
            if (heroMobile  && heroMobile.tagName && heroMobile.tagName.toLowerCase() === 'img') heroMobile.src = url;
          }

          function setSaleActiveUI(){
            if (state.chairChosen) container.classList.add('dsb-sale-active');
            else container.classList.remove('dsb-sale-active');

            if (totalPriceEl) totalPriceEl.classList.toggle('dsb-price--hidden', !state.chairChosen);
            if (mobileTotalPriceEl) mobileTotalPriceEl.classList.toggle('dsb-price--hidden', !state.chairChosen);
            if (mobileInlineTotalEl) mobileInlineTotalEl.classList.toggle('dsb-price--hidden', !state.chairChosen);
          }

          function getSelectedTableEl(){
            return isMobile() ? tableVariantElMobile : tableVariantElDesktop;
          }

          function getSelectedTableOption(el){
            if (!el) return null;
            if (el.tagName && el.tagName.toLowerCase() === 'select') {
              return el.options[el.selectedIndex];
            }
            return null;
          }

          function updateTableFromSelection() {
            var el = getSelectedTableEl();
            if (!el) return;

            state.tableVariantId = String(el.value);

            var opt = getSelectedTableOption(el);
            var priceAttr = opt ? opt.getAttribute('data-price') : el.getAttribute('data-price');
            var compareAttr = opt ? opt.getAttribute('data-compare') : el.getAttribute('data-compare');

            state.tablePriceCents = toCents(priceAttr);
            state.tableCompareCents = toCents(compareAttr);

            updateTotalsAndUI();
            renderAvailability();
          }

          function isTableOnOrder(){
            var el = getSelectedTableEl();
            if (!el) return false;
            var opt = getSelectedTableOption(el);
            var v = opt ? opt.getAttribute('data-onorder') : el.getAttribute('data-onorder');
            return v === 'true';
          }

          function tableNextPo(){
            var el = getSelectedTableEl();
            if (!el) return '';
            var opt = getSelectedTableOption(el);
            return (opt ? opt.getAttribute('data-nextpo') : el.getAttribute('data-nextpo')) || '';
          }

          function chairObj(){
            if (!state.chairHandle) return null;
            return (data.chairs && data.chairs[state.chairHandle]) ? data.chairs[state.chairHandle] : null;
          }

          function chairVariantObj(){
            var c = chairObj();
            if (!c || !state.chairVariantId) return null;
            return (c.variants || []).find(function(x){ return String(x.id) === String(state.chairVariantId); }) || null;
          }

          function setQty(q) {
            var requested = Number(q);
            // Clamp to an actual quantity option. If the requested value (e.g. a
            // stale "Default chair quantity") isn't one of the rendered buttons,
            // fall back to the first available option so we never calculate a
            // quantity the shopper can't see or change.
            var allowed = qtyButtons.map(function (b) { return Number(b.getAttribute('data-qty')); });
            if (allowed.length && allowed.indexOf(requested) === -1) {
              requested = allowed[0];
            }
            state.qty = requested;
            qtyButtons.forEach(function (b) {
              b.setAttribute('aria-pressed', Number(b.getAttribute('data-qty')) === requested ? 'true' : 'false');
            });
            updateTotalsAndUI();
          }

          function syncPressed(handle){
            chairButtons.forEach(function(b){
              var same = String(b.getAttribute('data-chair-handle')) === String(handle);
              b.setAttribute('aria-pressed', same ? 'true' : 'false');
            });
          }

          function populateChairVariants(chair) {
            function fill(selectEl, wrapEl){
              if (!selectEl) return;

              selectEl.innerHTML = '';
              (chair.variants || []).forEach(function (v) {
                var opt = document.createElement('option');
                opt.value = v.id;
                opt.textContent = v.title + (v.on_order ? ' (On Order)' : '');
                selectEl.appendChild(opt);
              });

              var hasMultiple = (chair.variants || []).length > 1;
              if (wrapEl) wrapEl.style.display = hasMultiple ? 'block' : 'none';

              var first = (chair.variants || []).find(function(v){ return !v.on_order; }) || (chair.variants || [])[0];
              if (first) {
                selectEl.value = first.id;
                state.chairVariantId = String(first.id);
                state.chairPriceCents = toCents(first.price);
                state.chairCompareCents = toCents(first.compare_at_price);
              }
            }

            fill(chairVariantElDesktop, chairVariantWrapDesktop);
            fill(chairVariantElMobile,  chairVariantWrapMobile);

            function bind(selectEl){
              if (!selectEl) return;
              selectEl.onchange = function(){
                var chosen = (chair.variants || []).find(function(v){ return String(v.id) === String(selectEl.value); });
                if (!chosen) return;
                state.chairVariantId = String(chosen.id);
                state.chairPriceCents = toCents(chosen.price);
                state.chairCompareCents = toCents(chosen.compare_at_price);
                updateTotalsAndUI();
                renderAvailability();
                updateDetails();
              };
            }

            bind(chairVariantElDesktop);
            bind(chairVariantElMobile);
          }

          function updateDetails(){
            var tTitle = (data.table && data.table.title) ? data.table.title : '';
            var tDesc  = (data.table && data.table.description_html) ? data.table.description_html : '';

            var c = chairObj();
            var cTitle = c ? c.title : 'Select a chair to view details';
            var cDesc  = c ? (c.description_html || '') : '<p>Select a chair above to see the chair details here.</p>';

            if (detailTableTitle) detailTableTitle.textContent = tTitle;
            if (detailTableDesc)  detailTableDesc.innerHTML = tDesc;

            if (detailChairTitle) detailChairTitle.textContent = cTitle;
            if (detailChairDesc)  detailChairDesc.innerHTML = cDesc;

            if (detailTableTitleM) detailTableTitleM.textContent = tTitle;
            if (detailTableDescM)  detailTableDescM.innerHTML = tDesc;

            if (detailChairTitleM) detailChairTitleM.textContent = cTitle;
            if (detailChairDescM)  detailChairDescM.innerHTML = cDesc;
          }

          function updateTotalsAndUI() {
            var tableCompare = state.tableCompareCents > 0 ? state.tableCompareCents : state.tablePriceCents;
            var chairCompare = state.chairCompareCents > 0 ? state.chairCompareCents : state.chairPriceCents;

            var qty = state.qty || 0;

            var totalCompare = tableCompare + (chairCompare * qty);
            var totalPrice = (state.tablePriceCents || 0) + ((state.chairPriceCents || 0) * qty);

            if (totalCompareEl) totalCompareEl.textContent = formatMoney(totalCompare);
            if (totalPriceEl)   totalPriceEl.textContent = formatMoney(totalPrice);

            if (mobileTotalCompareEl) mobileTotalCompareEl.textContent = formatMoney(totalCompare);
            if (mobileTotalPriceEl)   mobileTotalPriceEl.textContent = formatMoney(totalPrice);

            if (mobileInlineCompareEl) mobileInlineCompareEl.textContent = formatMoney(totalCompare);
            if (mobileInlineTotalEl)   mobileInlineTotalEl.textContent = formatMoney(totalPrice);

            setSaleActiveUI();
          }

          function renderAvailability(){
            var show = !!state.chairChosen;

            if (availabilityDesktop) availabilityDesktop.style.display = show ? 'block' : 'none';
            if (availabilityMobileSticky) availabilityMobileSticky.style.display = show ? 'block' : 'none';
            if (availabilityMobileInline) availabilityMobileInline.style.display = show ? 'block' : 'none';
            if (!show) return;

            var tOnOrder = isTableOnOrder();
            var tDue = tableNextPo();

            var cv = chairVariantObj();
            var cOnOrder = cv ? !!cv.on_order : false;
            var cDue = cv ? (cv.next_po || '') : '';

            function rowHtml(isOnOrder, inStockText, onOrderText, dueDate){
              if (!isOnOrder){
                return '<div class="dsb-av-row"><span class="dsb-dot dsb-dot--green"></span><div class="dsb-av-text">'+ inStockText +'</div></div>';
              }
              var due = dueDate ? (' — arriving ' + dueDate) : '';
              return '<div class="dsb-av-row"><span class="dsb-dot dsb-dot--amber"></span><div class="dsb-av-text">'+ onOrderText + due +'</div></div>';
            }

            var html =
              rowHtml(tOnOrder, 'Table in stock ready for delivery', 'Table on order', tDue) +
              rowHtml(cOnOrder, 'Chairs in stock ready for delivery', 'Chairs on order', cDue);

            if (availabilityDesktop) availabilityDesktop.innerHTML = html;

            if (availabilityMobileSticky) {
              availabilityMobileSticky.innerHTML = (tOnOrder || cOnOrder)
                ? ('<span>Incoming stock available to reserve' + (tDue || cDue ? (' • ' + (tDue || cDue)) : '') + '</span>')
                : ('<span>In stock ready for delivery</span>');
            }

            if (availabilityMobileInline) availabilityMobileInline.innerHTML = html;
          }

          function shouldShowMobileBar(){
            return !!(state.chairChosen && isMobile() && !state.inlineCtaVisible);
          }

          function applyMobileBarVisibility(){
            if (!mobileBar) return;

            if (shouldShowMobileBar()){
              mobileBar.classList.add('is-active');
              mobileBar.setAttribute('aria-hidden', 'false');
              container.classList.add('dsb-has-mobilebar');
            } else {
              mobileBar.classList.remove('is-active');
              mobileBar.setAttribute('aria-hidden', 'true');
              container.classList.remove('dsb-has-mobilebar');
            }
          }

          function setupInlineCtaObserver(){
            if (!mobileInlineCtaWrap || !('IntersectionObserver' in window)) {
              state.inlineCtaVisible = false;
              applyMobileBarVisibility();
              return;
            }

            var obs = new IntersectionObserver(function(entries){
              entries.forEach(function(entry){
                state.inlineCtaVisible = entry.isIntersecting;
                applyMobileBarVisibility();
              });
            }, { threshold: 0.15 });

            obs.observe(mobileInlineCtaWrap);
          }

          function dsbUpdateHeaderCartCount(count){
            var countStr = String(count);

            document.querySelectorAll('cart-count.count, cart-count').forEach(function(el){
              el.textContent = countStr;
              if (count === 0) el.setAttribute('hidden', '');
              else el.removeAttribute('hidden');
            });

            document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count, .site-header__cart-count').forEach(function(el){
              el.textContent = countStr;
            });
          }

          function dsbDispatchCartEvents(cart){
            try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } })); } catch(e){}
            try { window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } })); } catch(e){}
            try { window.dispatchEvent(new Event('cart:refresh')); } catch(e){}
            try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } })); } catch(e){}
          }

          async function dsbRefreshCartUI(){
            try{
              var r = await fetch('/cart.js', {
                credentials: 'same-origin',
                cache: 'no-store',
                headers: { 'Accept': 'application/json' }
              });
              if(!r.ok) return null;
              var cart = await r.json();
              dsbUpdateHeaderCartCount(cart.item_count || 0);
              dsbDispatchCartEvents(cart);
              return cart;
            }catch(e){
              return null;
            }
          }

          function dsbGetDrawerRoot(){
            return (
              document.querySelector('#CartDrawer') ||
              document.querySelector('cart-drawer') ||
              document.querySelector('[data-cart-drawer]') ||
              document.querySelector('.cart-drawer') ||
              document.querySelector('#cart-drawer')
            );
          }

          function dsbForceOpenDrawer(){
            const drawer = dsbGetDrawerRoot();
            if (!drawer) return;

            if (typeof drawer.open === 'function') { drawer.open(); return; }
            if (typeof drawer.show === 'function') { drawer.show(); return; }

            drawer.removeAttribute('hidden');

            const overlay = drawer.querySelector('overlay-element.overlay, .overlay, [aria-controls="CartDrawer"]');
            if (overlay) overlay.setAttribute('aria-expanded', 'true');

            const closeBtn = drawer.querySelector('[aria-controls="CartDrawer"]');
            if (closeBtn) closeBtn.setAttribute('aria-expanded', 'true');
          }

          async function dsbRefreshCartDrawerHTMLKeepOpen(){
            try{
              const oldDrawer = dsbGetDrawerRoot();
              if (!oldDrawer) return false;

              const wasOpen = !oldDrawer.hasAttribute('hidden');

              const url = new URL(window.location.href);
              url.searchParams.set('section_id', 'cart-drawer');

              const r = await fetch(url.toString(), {
                credentials: 'same-origin',
                cache: 'no-store',
                headers: { 'Accept': 'text/html' }
              });
              if (!r.ok) return false;

              const html = await r.text();
              const doc = new DOMParser().parseFromString(html, 'text/html');

              const freshDrawer =
                doc.querySelector('#CartDrawer') ||
                doc.querySelector('cart-drawer') ||
                doc.querySelector('[data-cart-drawer]') ||
                doc.querySelector('.cart-drawer') ||
                doc.querySelector('#cart-drawer');

              if (!freshDrawer) return false;

              oldDrawer.outerHTML = freshDrawer.outerHTML;

              if (wasOpen) {
                requestAnimationFrame(() => {
                  dsbForceOpenDrawer();
                });
              }

              try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch(e){}
              try { window.dispatchEvent(new CustomEvent('cart:updated')); } catch(e){}
              try { window.dispatchEvent(new Event('cart:refresh')); } catch(e){}

              return true;
            }catch(e){
              return false;
            }
          }

          async function handleAddToCart(){
            if (isAdding) return;
            isAdding = true;

            const setLoading = (on) => {
              [addBtnDesktop, addBtnMobileSticky, addBtnMobileInline].forEach(b => {
                if (!b) return;
                b.disabled = !!on;
                b.setAttribute('aria-busy', on ? 'true' : 'false');
              });
            };

            try {
              setMessage('');
              updateTableFromSelection();

              if (!state.chairVariantId) { setMessage('Please choose a chair colour first.'); return; }
              if (!state.qty) { setMessage('Please choose a chair quantity.'); return; }
              if (!state.tableVariantId) { setMessage('Please choose a table option.'); return; }

              const tableIdNum = parseInt(state.tableVariantId, 10);
              const chairIdNum = parseInt(state.chairVariantId, 10);
              if (!tableIdNum || !chairIdNum || isNaN(tableIdNum) || isNaN(chairIdNum)) {
                setMessage('Something went wrong (missing variant). Please reselect and try again.');
                return;
              }

              setLoading(true);

              const cartBefore = await dsbRefreshCartUI();
              const beforeCount = cartBefore && typeof cartBefore.item_count === 'number' ? cartBefore.item_count : null;

              const params = new URLSearchParams();
              params.append('items[0][id]', String(tableIdNum));
              params.append('items[0][quantity]', '1');
              params.append('items[1][id]', String(chairIdNum));
              params.append('items[1][quantity]', String(Number(state.qty)));

              let res, payload;
              try {
                res = await fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Accept': 'application/json' },
                  credentials: 'same-origin',
                  cache: 'no-store',
                  body: params
                });

                const ct = (res.headers.get('content-type') || '').toLowerCase();
                if (ct.includes('application/json')) payload = await res.json();
                else payload = await res.text();
              } catch (e) {}

              const cartAfter = await dsbRefreshCartUI();
              const afterCount = cartAfter && typeof cartAfter.item_count === 'number' ? cartAfter.item_count : null;

              const definitelyAdded =
                (beforeCount != null && afterCount != null && afterCount > beforeCount) ||
                (beforeCount == null && afterCount != null && afterCount > 0);

              if (!definitelyAdded) {
                const msg =
                  (payload && (payload.description || payload.message)) ?
                    (payload.description || payload.message) :
                    'Could not add set to cart. Please try again.';
                setMessage(msg, false);
                return;
              }

              setMessage('Added to cart ✅', true);

              try {
                await dsbRefreshCartDrawerHTMLKeepOpen();
                requestAnimationFrame(() => dsbForceOpenDrawer());
              } catch (e) {}

              if (redirectToCart) { window.location.href = '/cart'; return; }

            } catch (e) {
              console.error(e);
              setMessage('Could not add set to cart. Please try again.', false);
            } finally {
              isAdding = false;
              setLoading(false);
            }
          }

          chairButtons.forEach(function(btn){
            btn.addEventListener('click', function(){
              try {
                setMessage('');
                var handle = btn.getAttribute('data-chair-handle');
                var title = btn.getAttribute('data-chair-title') || 'Chair';
                var setHero = btn.getAttribute('data-chair-hero') || '';

                state.chairHandle = handle;
                syncPressed(handle);

                if (chairSelectedElDesktop) chairSelectedElDesktop.textContent = 'Selected: ' + title;
                if (chairSelectedElMobile) chairSelectedElMobile.textContent = 'Selected: ' + title;

                var chair = (data.chairs && data.chairs[handle]) ? data.chairs[handle] : null;
                if (!chair || !(chair.variants || []).length) throw new Error('Chair data missing for ' + handle);

                populateChairVariants(chair);

                if (setHero) setHeroImage(setHero);
                else if (chair.featured_image) setHeroImage(chair.featured_image);

                state.chairChosen = true;

                updateTotalsAndUI();
                renderAvailability();
                updateDetails();

                applyMobileBarVisibility();
              } catch(e){
                console.error(e);
                setMessage('Could not load chair options. Please try again.');
              }
            });
          });

          qtyButtons.forEach(function(btn){
            btn.addEventListener('click', function(){ setQty(btn.getAttribute('data-qty')); });
          });

          if (tableVariantElDesktop && tableVariantElDesktop.addEventListener) tableVariantElDesktop.addEventListener('change', updateTableFromSelection);
          if (tableVariantElMobile && tableVariantElMobile.addEventListener) tableVariantElMobile.addEventListener('change', updateTableFromSelection);

          if (addBtnDesktop) addBtnDesktop.addEventListener('click', handleAddToCart);
          if (addBtnMobileSticky) addBtnMobileSticky.addEventListener('click', handleAddToCart);
          if (addBtnMobileInline) addBtnMobileInline.addEventListener('click', handleAddToCart);

          window.addEventListener('resize', function(){
            if (accordionDesktop) accordionDesktop.open = true;
            if (accordionMobile) accordionMobile.open = true;
            applyMobileBarVisibility();
          });

          setQty(parseInt(container.dataset.defaultQty, 10) || 4);
          updateDetails();

          if (accordionDesktop) accordionDesktop.open = true;
          if (accordionMobile) accordionMobile.open = true;

          updateTableFromSelection();
          updateTotalsAndUI();
          renderAvailability();

          setupInlineCtaObserver();
          applyMobileBarVisibility();

          dsbRefreshCartUI();
        })();
